var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-card',{scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('h5',[_vm._v("Akses Inventaris")])]},proxy:true}])},[_c('ActionInventatis'),_c('AksesInventatis',{attrs:{"akseslists":_vm.akseslists}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }